<template>
  <section class="section">
    <div class="container split">
      <div>
        <h1>Fine Art</h1>
        <p class="lead">
          Une couverture hautement spécialisée pour les œuvres d’art, collections et objets
          de valeur, avec expertise et discrétion.
        </p>
        <ul class="list">
          <li>Garanties tous risques, transport et exposition</li>
          <li>Évaluation, inventaire et conservation</li>
          <li>Solutions sur mesure pour collections privées</li>
          <li>Gestion de sinistres avec experts dédiés</li>
          <li>Accompagnement lors d’acquisitions et de cessions</li>
        </ul>
      </div>
      <div class="panel">
        <h2>Accompagnement expert</h2>
        <p>Nous collaborons avec des spécialistes pour sécuriser chaque pièce.</p>
        <router-link class="button primary" to="/contact">Parler à un expert Fine Art</router-link>
      </div>
    </div>
  </section>
</template>
